import React, { useState } from 'react';

import { Container } from 'react-bootstrap';
import Header from './Header';
import Sidebar from './Sidebar';

interface Props {
  children: React.ReactNode;
}

const Page = ({ children }: Props): React.ReactElement => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div id="wrapper">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      {/* <side-nav :side-nav-toggled="sideNavToggled" :set-side-nav-toggled="setSideNavToggled" /> */}
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />{' '}
          <Container fluid>
            <div className="px-lg-5 pt-2">{children}</div>
          </Container>
        </div>
      </div>
    </div>

    // <>

    //   {children}
    // </>
    // <div className="flex h-screen bg-gray-200">
    //   <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
    //   <div className="flex-1 flex flex-col overflow-hidden">
    //     <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
    //       <div className="container mx-auto px-6 py-8">{children}</div>
    //     </main>
    //   </div>
    // </div>
  );
};

export default Page;
